import React from "react"
import "./style.scss"

export default()=><div id="section--about" 
className='stretch'>
this is the about page
</div>
